module.exports = __webpack_public_path__ + "img/AT0000002606141.3e18d232.png";